import { API } from '../api/API';
import useAuthStore from '../store/authStore';

const assureService = {
  
  // Récupérer tous les assurés
  getAllAssures: async (page = 1, limit = 100, search = '', is_active = '') => {
    try {
      const store = useAuthStore.getState();
      const params = { 
        page, 
        limit, 
        search,
        is_active,
        structure_id: store.user?.structure_id
      };
      
      const response = await API.get('/assures', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des assurés:', error);
      throw error;
    }
  },

  // Créer un nouvel assuré
  createAssure: async (assureData) => {
    try {
      const store = useAuthStore.getState();
      if (!assureData.structure_id) {
        assureData.structure_id = store.user?.structure_id;
      }
      const response = await API.post('/assures', assureData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de l\'assuré:', error);
      throw error;
    }
  },

  // Récupérer un assuré par ID
  getAssureById: async (id) => {
    try {
      const response = await API.get(`/assures/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'assuré:', error);
      throw error;
    }
  },

  // Récupérer un assuré par matricule
  getAssureByMatricule: async (matricule) => {
    try {
      const response = await API.get(`/assures/matricule/${matricule}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'assuré:', error);
      throw error;
    }
  },

  // Mettre à jour un assuré
  updateAssure: async (id, updateData) => {
    try {
      const response = await API.put(`/assures/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'assuré:', error);
      throw error;
    }
  },

  // Supprimer un assuré
  deleteAssure: async (id) => {
    try {
      const response = await API.delete(`/assures/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'assuré:', error);
      throw error;
    }
  },

  // Récupérer le profil complet d'un assuré
  getProfil: async (id) => {
    try {
      const response = await API.get(`/assures/${id}/profil`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du profil:', error);
      throw error;
    }
  },

  // Récupérer les prescriptions d'un assuré
  getPrescriptions: async (matricule) => {
    try {
      const response = await API.get(`/assures/${matricule}/prescriptions`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des prescriptions:', error);
      throw error;
    }
  }
};

export default assureService;